//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import ReactSelectComponent from 'app_components/commons/reactSelect'
import IconComponent from 'app_components/commons/icons'
import ModalCourseSchedulingSessionForm from 'app_components/modules/admin/courseScheduling/modalCourseSchedulingSessionForm'
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors';
// @end

// @INFO Import types
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
// @end

// @INFO Import services
import DurationFieldService from 'app_services/components/durationFieldService'
import CourseMasterService from 'app_services/admin/course/courseMasterService'
import UserService from 'app_services/user/userService'
// @end

// @INFO Import Styles
import './../courseSchedulingDetailsFormModule.scss'
import QualifiedTeacherService from 'app_services/admin/qualifiedTeacher/qualifiedTeacherService';
import ModalReprogramingForm from 'app_components/modules/ModalReprogramingForm/ModalReprogramingForm';

const uuid = require('react-uuid')

// @ADD Component types
interface ICourseSchedulingDetailsFormModuleLayoutProps {
  processing    : boolean
  onHandleSubmit: (data: any) => void
  editData?: any
  customErrors?: any
  viewer: boolean
  courseScheduling: ICourseSchedulingListItem | null
  scheduling: string[]
}

const CourseSchedulingDetailsFormModuleLayout: React.FC<ICourseSchedulingDetailsFormModuleLayoutProps> = (props) => {

  const [colors] = useColors()

  // @Services
  const durationFieldService: DurationFieldService = new DurationFieldService()
  const courseMasterService: CourseMasterService = new CourseMasterService()
  const userService: UserService = new UserService()
  const qualifiedTeacherService = new QualifiedTeacherService();

  const [totalProgramDuration, setTotalProgramDuration] = useState<number>(props?.courseScheduling?.total_scheduling || 0)
  const [firstLoad, setFirstLoad] = useState(true);


  const [endDate, setEndDate] = useState<any>({
    value: props?.editData?.details?.endDate
      ? moment.utc(props?.editData?.details?.endDate).format('YYYY-MM-DD')
      : moment.utc(props?.courseScheduling?.startDate.replace('T00:00:00.000Z', '')).format('YYYY-MM-DD'),
    min: props?.editData?.details?.startDate
      ? props?.editData?.details?.startDate.replace('T00:00:00.000Z', '')
      : props?.courseScheduling?.startDate.replace('T00:00:00.000Z', ''),
    max: props?.courseScheduling?.endDate.replace('T00:00:00.000Z', '')
  })
  const [endDateCalculated, setEndDateCalculated] = useState<string>('')
  // const [minEndDate, setMinEndDate] = useState<any>(props?.courseScheduling?.startDate.replace('T00:00:00.000Z', ''))
  const [modalCourseSchedulingSessionFormStatus, setModalCourseSchedulingSessionFormStatus] = useState<boolean>(false)
  const [programNumberOfSessionsStatus, setProgramNumberOfSessionsStatus] = useState<number|null>(null)
  const [courseDurationStatus, setCourseDurationStatus] = useState<boolean>(false)
  const [openReprogramingForm, updateOpenReprogramingForm] = useState<boolean>(false);
  const [reprogramingValue, setReprogramingValue] = useState<string|undefined>(undefined)

  const [courseDuration, setCourseDuration] = useState<number>(0)
  const [sessionStatus, setSessionStatus] = useState<boolean>(false)
  const [sessionEditData, setSessionEditData] = useState<any>(null)

  const [listOfCourses, setListOfCourses] = useState<Array<any>>([])
  const [listOfTeachers, setListOfTeachers] = useState<Array<any>>([])
  const [listOfSessions, setListOfSessions] = useState<Array<any>>([])

  const { t } = useTranslation()

  const formHook = useForm({ mode: 'onChange' })

  const courseSpy = formHook.watch('course');

  const reprogramingFormClosed = (data: any) => {
    updateOpenReprogramingForm(false)
    setReprogramingValue(undefined)
    formHook.setValue('reprograming', undefined)
    if (data?.status === 'saved' && data?.data?.reason) {
      setReprogramingValue(data?.data?.reason?.value)
      props.onHandleSubmit(formHook.getValues())
    }
  }

  useEffect(() => {
    getCourses()
    // getTeachers()
  }, [])

  useEffect(() => {
    if (courseSpy?.code) {
      getTeachers(courseSpy?.code);
    }
  }, [courseSpy])

  const getCourses = async () => {
    if (props.courseScheduling?.moodle_id) {
      const courses: Array<any> = []
      const coursesResponse = await courseMasterService.list({
        courseID: props.courseScheduling?.moodle_id
      }, {show_error: false})
      if (coursesResponse?.courseContents) {
        coursesResponse.courseContents.map((course: any) => {
          if (
            (!props.editData && !props.scheduling.includes(course.id.toString())) ||
            props.editData
          ) {
            courses.push({ value: course.id, label: `${course.description} | ${course.name} `, code: course.description})
          }
        })
      }
      setListOfCourses(courses)
    }
  }

  const getTeachers = async (code: string) => {
    const teachers: Array<any> = []
    const teachersResponse: any = await qualifiedTeacherService.listQualifiedTeachers({courseCode: code, status: 'ACTIVO'})
    if (teachersResponse?.qualifiedTeachers) {
      let _qualifiedTeachers: any[] = teachersResponse.qualifiedTeachers;
      if (_qualifiedTeachers) {
        _qualifiedTeachers = _qualifiedTeachers.sort((a,b) => {
          if (a?.teacher?.profile?.first_name > b?.teacher?.profile?.first_name) {
            return 1;
          }
          if (b?.teacher?.profile?.first_name > a?.teacher?.profile?.first_name) {
              return -1;
          }
          return 0;
        });
        _qualifiedTeachers.map((module: any) => {
          const teacher = module?.teacher;
          if (teacher?._id) {
            teachers.push({ value: teacher?._id, label: `${teacher?.profile?.first_name} ${teacher?.profile?.last_name}` });
          } else {
            console.error("Qualified teacher without teacher user: ", module)
          }
        })
      }
    }
    setListOfTeachers(teachers)
  }

  const handleModalSessionForm = () => {
    setModalCourseSchedulingSessionFormStatus(true)
  }

  const editSession = (session: number) => {
    setSessionEditData(session)
    setModalCourseSchedulingSessionFormStatus(true)
  }

  const removeSession = (index: number) => {
    let sessions = [...listOfSessions]
    sessions.splice(index, 1)
    setListOfSessions(sessions)
    formHook.setValue('sessions', sessions)
  }

  const handleCloseModal = (data: any) => {
    setSessionEditData(null)
    setModalCourseSchedulingSessionFormStatus(false)

    if (data?.status === true && data?.data) {
      let sessions = [...listOfSessions]
      if (data?.data?.uuid) {
        if (data?.data?.hasChanges === 'on') {
          const find = sessions.findIndex((session) => session.uuid === data?.data?.uuid)
          if (find !== -1) {
            sessions[find] = {
              uuid: data?.data?.uuid,
              startDate: data?.data?.startDate,
              duration: data?.data?.duration,
              hasChanges: data?.data?.hasChanges,
              reinforcement_class: data?.data?.reinforcement_class || false,
              isNew: false,
              oldValues: {...sessions[find]}
            }
          }
        }
      } else {
        sessions.push({
          uuid: uuid(),
          startDate: data?.data?.startDate,
          duration: data?.data?.duration,
          hasChanges: data?.data?.hasChanges,
          reinforcement_class: data?.data?.reinforcement_class || false,
          isNew: true,
        })
      }
      sessions.sort((a, b) => moment.utc(a.startDate).diff(moment.utc(b.startDate)))
      const lastSession = sessions[sessions.length - 1];
      if (lastSession) {
        const _endDate = moment(lastSession.startDate).add(lastSession.duration, 'seconds')
        setEndDateCalculated(_endDate.format('YYYY-MM-DD HH:mm:ss'))
        formHook.setValue('endDate', _endDate.format('YYYY-MM-DD HH:mm:ss'))
      }
      setListOfSessions(sessions)
      formHook.setValue('sessions', sessions)
    }
  }

  const handleNumberOfSessionsChange = (event: any) => {
    if (event.target.value && event.target.value !== "") {
      setProgramNumberOfSessionsStatus(parseInt(event.target.value))
      setProgramNumberOfSessionsStatus(parseInt(event.target.value))
      // let sessions = [...listOfSessions]
      // sessions.splice(0, parseInt(event.target.value))
      // setListOfSessions(sessions)
    } else {
      setProgramNumberOfSessionsStatus(null)
      setProgramNumberOfSessionsStatus(null)
    }
  }

  const calculateDurationProgramming = () => {
    const sessionsDuration = listOfSessions.reduce((accum, element) => {
      return accum + element.duration
    }, 0)

    if (sessionsDuration > 0) {
      return (
        <div className={`alert ${sessionsDuration > courseDuration ? 'alert-warning' : 'alert-info'}`}>
          <div className="duration-programming">
            {t('modules.course_scheduling.details.form.duration_programming', {duration: durationFieldService.getDurationFormated(sessionsDuration)})}
          </div>
        </div>
      )
    }
    return (
      <div className="alert alert-info">
        <div className="duration-programming">{t('modules.course_scheduling.details.form.program_without_duration')}</div>
      </div>
    )
  }

  const handleCourseDurationChange = (data: any) => {
    let duration = durationFieldService.getSecondsFromDuration(data)
    setCourseDuration(duration)
    if (duration > 0) {
      setCourseDurationStatus(true)
    } else {
      setCourseDurationStatus(false)
    }
  }

  useEffect(() => {
    if (props?.courseScheduling?.schedulingMode?.name === 'Virtual') {
      setSessionStatus(false)
    } else {
      setSessionStatus(true)
    }
  }, [props.courseScheduling])


  useEffect(() => {
    if (props?.editData && firstLoad) {
      if (props?.editData?.details?.number_of_sessions) {
        setProgramNumberOfSessionsStatus(props?.editData?.details?.number_of_sessions)
      }

      if (props?.editData?.details?.duration && props?.editData?.details?.duration > 0) {
        setCourseDurationStatus(true)
        setCourseDuration(props?.editData?.details?.duration)

        if (props?.courseScheduling?.schedulingMode?.name === 'Virtual') {
          setTotalProgramDuration(totalProgramDuration - (props?.editData?.details?.duration || 0))
        }
      }

      if (props?.editData?.details?.sessions && Array.isArray(props?.editData?.details?.sessions) && props?.editData?.details?.sessions.length > 0) {
        let sessions = props?.editData?.details?.sessions.reduce((accum: any, element: any) => {
          accum.push({
            ...element,
            uuid: uuid()
          })
          return accum
        }, [])
        sessions.sort((a: any, b: any) => moment.utc(a.startDate).diff(moment.utc(b.startDate)))
        setListOfSessions(sessions)

        const sessionsDuration = sessions.reduce((accum: any, element: any) => {
          return accum + element.duration
        }, 0)

        if (props?.editData?.details?.endDate) {
          const _endDate = moment.utc(props?.editData?.details?.endDate)
          setEndDateCalculated(_endDate.format('YYYY-MM-DD HH:mm:ss'))
          formHook.setValue('endDate', _endDate.format('YYYY-MM-DD HH:mm:ss'))
        }


        setTotalProgramDuration(totalProgramDuration - sessionsDuration)
        formHook.setValue('sessions', sessions)
      }

      setFirstLoad(false)
    }
  }, [props,props.editData])

  const checkSchedulingLabel = () => {
    let programDuration: {label: null | string, value: number} = {
      label: null,
      value: 0
    }
    let programing: {label: null | string, value: number} = {
      label: null,
      value: 0
    }
    const sessionsDuration = listOfSessions.reduce((accum, element) => {
      return accum + element.duration
    }, 0)

    if (props?.courseScheduling?.duration) {
      programDuration.label = durationFieldService.getDurationFormated(props?.courseScheduling?.duration)
      programDuration.value = props?.courseScheduling?.duration
    }

    if (sessionStatus) {
      const total_scheduling = (totalProgramDuration || 0) + sessionsDuration
      if (total_scheduling > 0) {
        programing.label = durationFieldService.getDurationFormated(total_scheduling)
        programing.value = total_scheduling
      }
    } else {
      const total_scheduling = (totalProgramDuration || 0) + courseDuration
      if (total_scheduling > 0) {
        programing.label = durationFieldService.getDurationFormated(total_scheduling)
        programing.value = total_scheduling
      }
    }

    if (!programDuration.label) {
      return (
        <div className="alert alert-info">
          <span>{t('modules.course_scheduling.details.scheduling_labels.program_without_duration')}</span>
        </div>
      )
    } else {
      if (!programing.label) {
        return (
          <div className="alert alert-info">
            <span>{t('modules.course_scheduling.details.scheduling_labels.program_without_sessions', {program_duration: programDuration.label})}</span>
          </div>
        )
      } else {
        return (
          <div className={`alert ${programing.value > programDuration.value ? 'alert-warning' : 'alert-info'}`}>
            <div className="duration-programming">
              {t('modules.course_scheduling.details.scheduling_labels.program_with_sessions', {program_duration: programDuration.label, sessions: programing.label})}
            </div>
          </div>
        )
      }
    }

    // <div className="alert alert-info">
    //   <span>{}</span>
    // </div>
  }

  return(
    <div className='course_scheduling_details_form-component'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>

        <input type="hidden" name="reprograming" value={reprogramingValue} ref={formHook.register({ required: false })} />

          {props?.courseScheduling?.duration && (
            <>
              {checkSchedulingLabel()}
            </>
          )}
          <input
            type="hidden"
            name="course_scheduling"
            defaultValue={(props.courseScheduling?._id) ? props.courseScheduling._id : ''}
            ref={formHook.register({ required: true })}
          />

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.course_scheduling.details.general_information")}</h3>
          </div>

          <div className="row">

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='course'>{t('labels.course_scheduling.details.course')}</label>
                <ReactSelectComponent
                  identifier='course'
                  options={listOfCourses}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.course) ? [{value: parseInt(props?.editData?.details?.course.moodle_id), label: `${props?.editData?.details?.course.code} | ${props?.editData?.details?.course.name}`, code: props?.editData?.details?.course?.code}] : []}
                  isMulti={false}
                  required={true}
                />
                {formHook.errors.course && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor='startDate'>{t('labels.course_scheduling.details.startDate')}</label>
                <input
                  type='date'
                  className='form-control'
                  name='startDate'
                  defaultValue={
                    props?.editData?.details?.startDate
                      ? moment.utc(props?.editData?.details?.startDate).format('YYYY-MM-DD')
                      : moment.utc(props?.courseScheduling?.startDate.replace('T00:00:00.000Z', '')).format('YYYY-MM-DD')
                    }
                  ref={formHook.register({ required: true })}
                  min={props?.courseScheduling?.startDate.replace('T00:00:00.000Z', '')}
                  max={props?.courseScheduling?.endDate.replace('T00:00:00.000Z', '')}
                  onChange={(event) => {
                    setEndDate({...endDate, value: event.target.value, min: event.target.value})
                  }}
                />
                {formHook.errors.startDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">

                {sessionStatus ? (
                  <>
                    <label htmlFor='endDate'>{t('labels.course_scheduling.details.endDate')}</label>
                    <input
                      type='text'
                      className='form-control'
                      name='endDate'
                      value={endDateCalculated}
                      defaultValue={endDateCalculated}
                      // defaultValue={props?.editData?.details?.endDate ? moment.utc(props?.editData?.details?.endDate).format('YYYY-MM-DD') : '-'}
                      ref={formHook.register({ required: true })}
                      readOnly
                    />
                    {formHook.errors.endDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </>
                ): (
                  <>
                    <label htmlFor='endDate'>{t('labels.course_scheduling.details.endDate')}</label>
                    <input
                      type='date'
                      className='form-control'
                      name='endDate'
                      value={endDate.value}
                      defaultValue={endDate.value}
                      ref={formHook.register({ required: true })}
                      min={endDate.min}
                      // max={endDate.max}
                      onChange={(event) => {
                        setEndDate({...endDate, value: event.target.value})
                      }}
                    />
                    {formHook.errors.endDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='teacher'>{t('labels.course_scheduling.details.teacher')}</label>
                <ReactSelectComponent
                  identifier='teacher'
                  options={listOfTeachers}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.teacher) ? [{value: props?.editData?.details?.teacher?._id, label: `${props?.editData?.details?.teacher?.profile?.first_name} ${props?.editData?.details?.teacher?.profile?.last_name}`}] : []}
                  isMulti={false}
                  required={true}
                />
                {formHook.errors.teacher && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='duration'>{t('labels.course_scheduling.details.duration')}</label>
                {formHook.errors.duration && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='duration'
                  name='duration'
                  className={`form-control ${formHook.errors.duration && 'is-invalid'}`}
                  type='text'
                  placeholder='0h 0m 0s'
                  ref={formHook.register({ required: true })}
                  defaultValue={(props?.editData?.details?.duration) ? durationFieldService.getDurationFormated(props?.editData?.details?.duration) : ''}
                  onChange={(data) => handleCourseDurationChange(data.target.value)}
                />
              </div>
              {props.customErrors?.duration_invalid && <div className='custom-invalid-feedback'>{props.customErrors?.duration_invalid}</div>}
            </div>

            {sessionStatus && (
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='number_of_sessions'>{t('labels.course_scheduling.details.number_of_sessions')}</label>
                  {formHook.errors.number_of_sessions && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    name='number_of_sessions'
                    className={`form-control ${formHook.errors.number_of_sessions && 'is-invalid'}`}
                    type='number'
                    pattern='[0-9]'
                    min='0'
                    ref={formHook.register({ required: true })}
                    defaultValue={(props?.editData?.details?.number_of_sessions) ? props?.editData?.details?.number_of_sessions : ''}
                    onChange={handleNumberOfSessionsChange}
                  />
                </div>
              </div>
            )}

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='observations'>{t('labels.course_scheduling.details.observations')}</label>
                {formHook.errors.observations && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <textarea
                  id='observations'
                  name='observations'
                  className={`form-control ${formHook.errors.observations && 'is-invalid'}`}
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.observations}
                />
              </div>
            </div>
          </div>

          {sessionStatus && (
            <>
              <div className="d-flex align-items-center mb-2">
                <h3 className="form-title">{t("modules.course_scheduling.sessions")}</h3>
              </div>

              {props.customErrors?.number_of_sessions_invalid && (
                <>
                  <div className='custom-invalid-feedback'>{props.customErrors?.number_of_sessions_invalid}</div><br />
                </>
              )}

              {programNumberOfSessionsStatus && courseDurationStatus ? (
                <div className="row mb-3">
                  {!props.viewer && (
                    <>
                    {listOfSessions.length < programNumberOfSessionsStatus && (
                      <div className="col-12 text-right">
                        <button className="btn btn-primary" onClick={handleModalSessionForm} type="button">
                          <IconComponent fontawesome={{icon: 'fa fa-plus'}} />&nbsp;&nbsp;
                          {t("modules.course_scheduling.form.add_session")}
                        </button>
                      </div>
                    )}
                    </>
                  )}
                  <div className="col-12 sessions-list mt-3">
                    {/* <div className="duration-without-programming">{calculateDurationWithoutProgramming()}</div> */}
                    {calculateDurationProgramming()}
                    {listOfSessions.length > 0 ? (
                      <>
                        {listOfSessions.map((session, index) => (
                          <div className="session-item" key={`session_${index}`}>
                            <div className="session-index">{index+1}</div>
                            <div className="session-content">
                              <div>
                                <span>{t("modules.course_scheduling.form.sessions.startDate")}: {moment(session.startDate).format('DD/MM/YYYY hh:mm a')}</span>
                              </div>
                              <div>
                                <span>{t("modules.course_scheduling.form.sessions.duration")}: {durationFieldService.getDurationFormated(session.duration, 'short', false)}</span>
                              </div>
                              <div>
                                <span>{t("modules.course_scheduling.form.sessions.reinforcement_class")}: {`${(session?.reinforcement_class ? `Si` : `No`)}`}</span>
                              </div>
                            </div>
                            {!props.viewer && (
                              <div className="session-actions">
                                <OverlayTrigger
                                  trigger={['hover', 'focus']}
                                  placement={'top'}
                                  overlay={
                                    <Tooltip id='toolip-circle'>
                                      {t("modules.course_scheduling.form.sessions.edit")}
                                    </Tooltip>
                                  }>
                                    <div className="session-action" onClick={() => editSession(session)}>
                                      <IconComponent fontawesome={{icon: 'fas fa-edit'}} color={colors.primary} />
                                    </div>
                                </OverlayTrigger>
                                &nbsp;&nbsp;
                                <OverlayTrigger
                                  trigger={['hover', 'focus']}
                                  placement={'top'}
                                  overlay={
                                    <Tooltip id='toolip-circle'>
                                      {t("modules.course_scheduling.form.sessions.delete")}
                                    </Tooltip>
                                  }>
                                    <div className="session-action" onClick={() => removeSession(index)}>
                                      <IconComponent fontawesome={{icon: 'fas fa-trash-alt'}} color={colors.primary} />&nbsp;&nbsp;
                                    </div>
                                </OverlayTrigger>
                              </div>
                            )}
                          </div>
                        ))}
                        {formHook.register({name: 'sessions', required: true, value: listOfSessions})}
                      </>
                    ) : (
                      <AlertComponent
                        type='warning'
                        title={t('modules.course_scheduling.form.sessions.no_data')}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-12">
                    <AlertComponent
                      type='warning'
                      title={t('modules.course_scheduling.form.duration_required')}
                    />
                  </div>
                </div>
              )}
            </>
          )}

          {!props.viewer && (
            <div className='buttons-group'>
              <div className=''>
                <button className='btn btn-primary' type='submit' disabled={props.processing}>
                  {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                  {t('buttons.save')}
                </button>
                {props.editData && userService.can('permission:course_scheduling_reprogramming', 'module:course_scheduling') && (
                  <>
                    &nbsp;&nbsp;
                    <button className='btn btn-primary' type='button' disabled={props.processing || !formHook.formState.isValid} onClick={() => updateOpenReprogramingForm(true)}>
                      {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                      Guardar y generar reprogramación
                    </button>
                  </>
                )}
              </div>
            </div>
          )}

        </form>
      </fieldset>

      {modalCourseSchedulingSessionFormStatus && (
        <ModalCourseSchedulingSessionForm
          open={modalCourseSchedulingSessionFormStatus}
          handleClose={handleCloseModal}
          editData={sessionEditData}
          minDate={formHook.getValues('startDate')}
          endDate={!sessionStatus ? formHook.getValues('endDate') : undefined}
        />
      )}
      <ModalReprogramingForm
        open={openReprogramingForm}
        onClose={(data) => reprogramingFormClosed(data)}
        title="Reprogramación de servicio"
      />
    </div>
  )
}

export default CourseSchedulingDetailsFormModuleLayout
